<template>
  <div class="page adv-page">
    <h1>{{ t('advTitle') }}</h1>
    <div class="row-2" style="margin-bottom:16px">
      <input v-model="keyword" :placeholder="t('search')" @keyup.enter="load" />
      <select v-model="severity" @change="load">
        <option value="">{{ t('allSeverity') }}</option>
        <option value="critical">{{ t('sevCritical') }}</option>
        <option value="high">{{ t('sevHigh') }}</option>
        <option value="medium">{{ t('sevMedium') }}</option>
        <option value="low">{{ t('sevLow') }}</option>
      </select>
    </div>
    <div class="form-actions" style="margin-top:0;margin-bottom:16px">
      <button class="btn btn-primary" type="button" @click="load">{{ t('search') }}</button>
    </div>
    <div v-if="loading" class="empty">{{ t('loading') }}</div>
    <div v-else-if="!rows.length" class="empty">{{ t('emptyAdv') }}</div>
    <div v-else class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>{{ t('advTitle') }}</th>
            <th>{{ t('severity') }}</th>
            <th>{{ t('product') }}</th>
            <th>{{ t('cve') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in rows" :key="row.id">
            <td>
              <router-link :to="'/advisories/' + row.id">{{ row.advisoryNo }} · {{ row.title }}</router-link>
            </td>
            <td><span class="tag" :class="tagClass(row.severity)">{{ sevText(row.severity) }}</span></td>
            <td>{{ row.affectedProduct }}</td>
            <td>{{ row.cveIds || '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { t } from '../i18n'
import { mapState } from 'vuex'
import { portalApi } from '../api/portalApi'

export default {
  name: 'Advisories',
  data() {
    return { keyword: '', severity: '', rows: [], loading: false }
  },
  computed: {
    ...mapState(['locale'])
  },
  created() {
    this.load()
  },
  methods: {
    t(key) {
      return t(this.locale, key)
    },
    sevText(code) {
      return ({
        critical: this.t('sevCritical'),
        high: this.t('sevHigh'),
        medium: this.t('sevMedium'),
        low: this.t('sevLow')
      })[code] || code
    },
    tagClass(code) {
      if (code === 'critical' || code === 'high') return 'danger'
      if (code === 'medium') return 'warn'
      return 'ok'
    },
    load() {
      const params = { pageIndex: 1, pageSize: 50 }
      if (this.keyword) params.keyword = this.keyword
      if (this.severity) params.severity = this.severity
      this.loading = true
      portalApi.advisories(params).then((rows) => {
        this.rows = Array.isArray(rows) ? rows : []
      }).catch(() => {
        this.rows = []
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
